document.addEventListener("DOMContentLoaded", () => {
  const gallery = document.querySelector(".swipe-gallery");
  const slides = gsap.utils.toArray(".swipe-gallery__slide");
  const numSlides = slides.length;
  const bgs = gsap.utils.toArray(".slide-bg");
  const slideTexts = gsap.utils.toArray(".slide-text");
  const slideImages = gsap.utils.toArray(".slide-image");
  const tabs = gsap.utils.toArray(".slide-tab");
  const bounceImages = gsap.utils.toArray(".bounce-image-step");

  gsap.set(tabs, {
    backgroundColor: "#ffffff",
    color: "#111111",
    display: "inline-block",
  });

  gsap.set(tabs[0], {
    backgroundColor: "#111111",
    color: "#ffffff",
  });

  gsap.set([bgs, slideTexts, slideImages, bounceImages], { opacity: 0 });
  gsap.set(bounceImages, { scale: 0.8 });
  gsap.set([bgs[0], slideTexts[0], slideImages[0]], { opacity: 1 });

  const perSlideScroll = window.innerHeight * 2;
  const totalScrollLength = perSlideScroll * (numSlides - 1);

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: gallery,
      start: "top top",
      end: `+=${totalScrollLength}`,
      pin: true,
      scrub: true,
    },
  });

  slides.forEach((slide, i) => {
    const slideStartTime = i * 2;

    tl.to(
      tabs[i],
      {
        backgroundColor: "#111111",
        color: "#ffffff",
        duration: 0.2,
        ease: "none",
      },
      slideStartTime
    );

    if (i > 0) {
      tl.to(
        tabs[i - 1],
        {
          backgroundColor: "#ffffff",
          color: "#111111",
          duration: 0.2,
          ease: "none",
        },
        slideStartTime
      );
    }

    if (i > 0) {
      tl.to(slideTexts[i - 1], { opacity: 0, duration: 0.5 }, slideStartTime);
      tl.to(slideTexts[i], { opacity: 1, duration: 0.5 }, slideStartTime);
    }

    if (i > 0) {
      tl.to(slideImages[i - 1], { opacity: 0, duration: 0.5 }, slideStartTime);
      tl.to(slideImages[i], { opacity: 1, duration: 0.5 }, slideStartTime);
    }

    tl.to(
      bounceImages[i],
      {
        opacity: 1,
        scale: 1,
        ease: "power2.out",
        duration: 0.7,
      },
      slideStartTime + 0.5
    );

    if (i > 0) {
      tl.to(
        bounceImages[i - 1],
        {
          opacity: 0,
          scale: 0.8,
          ease: "power2.out",
          duration: 0.3,
        },
        slideStartTime
      );
    }
  });
});
